module.exports = __webpack_public_path__ + "static/media/4-_DSC1112.68ba7344.jpg";